import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import 'element-plus/theme-chalk/display.css';

import 'swiper/css';

import JsonCSV from 'vue-json-csv';

//https://vue-select.org/api/props.html
// import vSelect from 'vue-select';
// import 'vue-select/dist/vue-select.css';

// // Set the components prop default to return our fresh components
// vSelect.props.components.default = () => ({
// 	OpenIndicator: {
// 		render: () => h('span', { class: 'select-arrow' }),
// 	},
// });

// @ts-ignore
import App from './App.vue';
import router from './router';
import store, { key } from './store';

import { registerGlobalProperties } from './plugins/globalProperties';

const app = createApp(App);

registerGlobalProperties(app);

/* SENTRY */
import * as Sentry from '@sentry/vue';

Sentry.init({
	app,
	dsn: 'https://462267322be9260d890c14dd35f0d6e9@o4506655608668160.ingest.us.sentry.io/4509122530443264',
});

app.use(store, key);
app.use(router);
app.use(ElementPlus);
// app.component('v-select', vSelect);
app.component('downloadCsv', JsonCSV);
app.mount('#app');
